import { render, staticRenderFns } from "./Tarifflevels.vue?vue&type=template&id=9a3f2a10&scoped=true&"
import script from "./Tarifflevels.vue?vue&type=script&lang=js&"
export * from "./Tarifflevels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a3f2a10",
  null
  
)

export default component.exports